import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../../lib/supabase';
import './SettingsPages.css';
import './AccountSettings.css';

function InactiveAccountView() {
  const { t } = useTranslation(['profile', 'shared']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleReactivate = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        setError(t('profile.settings.pages.account.inactiveAccount.errorNotLoggedIn'));
        setLoading(false);
        return;
      }

      // Aktualizacja is_active = true
      const { error: updateError } = await supabase
        .from('users')
        .update({ 
          is_active: true,
          deactivated_at: null
        })
        .eq('id', user.id);

      if (updateError) {
        throw updateError;
      }

      setSuccess(true);
      
      // Odświeżenie strony po krótkim opóźnieniu, aby zobaczyć komunikat sukcesu
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (err) {
      console.error('Error reactivating account:', err);
      setError(err.message || t('profile.settings.pages.account.inactiveAccount.errorReactivate'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-page-content">
        <div className="inactive-account-container">
          <div className="inactive-account-icon">⚠️</div>
          
          <h2 className="inactive-account-title">
            {t('profile.settings.pages.account.inactiveAccount.title')}
          </h2>
          
          <p className="inactive-account-description">
            {t('profile.settings.pages.account.inactiveAccount.description')}
          </p>

          <p className="inactive-account-support">
            {t('profile.settings.pages.account.inactiveAccount.supportIntro')}{' '}
            <a className="inactive-account-support-link" href="mailto:support@plangonow.com">
              support@plangonow.com
            </a>
          </p>

          <div className="inactive-account-consequences">
            <h3 className="inactive-account-consequences-title">
              {t('profile.settings.pages.account.inactiveAccount.consequencesTitle')}
            </h3>
            <ul className="inactive-account-consequences-list">
              <li>{t('profile.settings.pages.account.inactiveAccount.consequence1')}</li>
              <li>{t('profile.settings.pages.account.inactiveAccount.consequence2')}</li>
              <li>{t('profile.settings.pages.account.inactiveAccount.consequence3')}</li>
              <li>{t('profile.settings.pages.account.inactiveAccount.consequence4')}</li>
            </ul>
          </div>

          {error && (
            <div className="inactive-account-error">
              {error}
            </div>
          )}

          {success && (
            <div className="inactive-account-success">
              {t('profile.settings.pages.account.inactiveAccount.reactivateSuccess')}
            </div>
          )}

          <button
            className="inactive-account-button"
            onClick={handleReactivate}
            disabled={loading || success}
          >
            {loading 
              ? t('profile.settings.pages.account.inactiveAccount.reactivating')
              : success
              ? t('profile.settings.pages.account.inactiveAccount.reactivated')
              : t('profile.settings.pages.account.inactiveAccount.reactivateButton')
            }
          </button>
        </div>
      </div>
    </div>
  );
}

export default InactiveAccountView;





